"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var yotpo_img_1 = require("../../constants/img/yotpo-img");
var YotpoStar_1 = require("./YotpoStar");
var YotpoReviewReadMore_1 = require("./YotpoReviewReadMore");
var yotpo_img_2 = require("../../constants/img/yotpo-img");
var YotpoReviewCard = function (_a) {
    var review = _a.review;
    // Convert date string to desired format
    // ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString
    var date = new Date(review.created_at).toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
    // If isLongContent is true, this compornent renders YotpoReviewReadMore instead of review.content
    var isLongContent = review.content.length > 350;
    return ((0, preact_1.h)("div", { class: "yotpo-review-card" },
        (0, preact_1.h)("div", { class: "yotpo-review-card__top" },
            (0, preact_1.h)("div", { class: "yotpo-review-card__user" },
                (0, preact_1.h)("img", { class: "yotpo-review-card__avatar", src: review.user.social_image || yotpo_img_1.YOTPO_AVATAR, alt: "avatar" }),
                (0, preact_1.h)("div", { class: "yotpo-review-card__profile" },
                    (0, preact_1.h)("p", { class: "yotpo-review-card__name" }, review.user.display_name),
                    (0, preact_1.h)("p", { class: "yotpo-review-card__verified" }, "Verified Customer"))),
            (0, preact_1.h)("div", { class: "yotpo-review-card__date" }, date)),
        (0, preact_1.h)("div", { class: "yotpo-review-card__middle" },
            (0, preact_1.h)(YotpoStar_1.default, { score: review.score, id: "yotpo-review-star--".concat(review.id), color: "#FAA943", starFilledImg: yotpo_img_2.YOTPO_STAR_FILLED_ORANGE, starOutlinedImg: yotpo_img_2.YOTPO_STAR_OUTLINED_ORANGE }),
            (0, preact_1.h)("div", { class: "yotpo-review-card__title" }, review.title)),
        (0, preact_1.h)("hr", { class: "yotpo-review-card__divider" }),
        (0, preact_1.h)("div", { class: "yotpo-review-card__bottom" },
            (0, preact_1.h)("div", { class: "yotpo-review-card__content" }, isLongContent ? (0, preact_1.h)(YotpoReviewReadMore_1.default, { content: review.content }) : review.content),
            (0, preact_1.h)("div", { class: "yotpo-review-card__imgs" }))));
};
exports.default = YotpoReviewCard;
